import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['section', 'effectivenessReviewAdjustedFields'];

  switchQuestionType = (event) => {
    const type = event.detail.newValue;
    this.element.dataset.questionType = type;
    this.sectionTargets.forEach((section) => {
      const visible = section.dataset.questionTypes.split(',').includes(type);
      section.hidden = !visible;
      section.disabled = !visible;
    });
  };

  toggleEffectivenessReviewFields = (event) => {
    if (event.target.type !== 'checkbox') return;
    this.effectivenessReviewAdjustedFieldsTarget.hidden = !event.target.checked;
  };
}
